// Lightweight Stripe config helper. NOTE: do NOT import @stripe/stripe-js
// here — that package auto-injects js.stripe.com on import. The actual
// Stripe loading lives in components/organisms/StripePaymentForm.jsx, which
// is lazy-loaded only when a payment is started.

const PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";

export const isStripeConfigured = () =>
  PUBLISHABLE_KEY.length > 0 && !PUBLISHABLE_KEY.endsWith("PLACEHOLDER");
